import { Component, Input, SimpleChanges } from '@angular/core';
import { SearchService } from '../search.service';
import { FirestoreService } from '../firestore-service.service';
import { Post, PostField, Template, TemplateField } from '../container';
import { MatDialog } from '@angular/material/dialog';
import { AddworkpackagedialogComponent } from '../addworkpackagedialog/addworkpackagedialog.component';
import { Router } from '@angular/router';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-similarcontent',
    templateUrl: './similarcontent.component.html',
    styleUrls: ['./similarcontent.component.scss'],
    imports: [
      CommonModule,
      ConfirmingDialogComponent
    ],
    standalone: true
})
export class SimilarcontentComponent {
  @Input()organizationKey: string = "";
  @Input()projectKey: string = "";
  @Input()projectName: string = "";
  @Input()contentKey: string = "";
  @Input()embedding: number[] = [];
  @Input()userId: string = ""
  @Input()isReadOnly = false
  @Input() embeddingModel = ""
  responseVectors: {"id": string, "score": number, "value": number[]}[] = []
  responseChunks: {key: string, chunk: string, documentKey: string, documentName: string, "cosine": number, "order": number, "url": string, "coverImageURL": string, "contentType": string}[] = []
  gptResponse = ""
  similarDocuments: {"key": string, "name": string, "url": string, "ners": {"type": string, "content": string}[],  "coverImageURL": string, "contentKey": string, "contentType": string, "type": string}[] = []
  templates: Template[] = []
  channelKey = ""
  channelPath = ""
  loggeduserDisplayname = ""
  loggeduserEmail = ""
  loggeduserPhotoURL = ""
  menuItems: {key: string, name: string, color: string}[] = []
  fieldKeyWithLinks = -1

  constructor(private router: Router, public dialog: MatDialog, private searchService: SearchService, private firestore: FirestoreService) {
  }

  ngAfterViewInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contentKey']) {
      this.firestore.getContentEmbedding(this.organizationKey, this.contentKey).then((result) => {
        this.embedding = result
        this.sendQuery()
      })
    }
  }

  sendQuery() {
    if (this.embedding && this.embedding.length > 0) {
      this.responseChunks.length = 0
      this.similarDocuments.length = 0
      this.responseVectors.length = 0
      this.searchService.queryVector(this.organizationKey, this.embedding, ["post"], 10).then((result: any) => {
       this.responseChunks = result.responseChunks
       if (result.responseSourceDocuments != undefined) {
        result.responseSourceDocuments.forEach((doc: any) => {
          doc.name = doc.name.slice(0, 70) + "..." // shorten name to 50 characters
          if ( this.contentKey != doc.key) { 
            this.similarDocuments.push(doc)
          }
         })
         const fileURLs = result.fileURLs
         const coverImageURLs = result.coverImageURLs
         for (let i = 0; i < this.similarDocuments.length; i++) {
          for (let j = 0; j < fileURLs.length; j++) { // match urls with search result documents or posts
            if (this.similarDocuments[i].key == fileURLs[j].key) {
              this.similarDocuments[i].url = fileURLs[j].url
            }
          }
          for (let j = 0; j < coverImageURLs.length; j++) { // match cover images with search results documents
            if (this.similarDocuments[i].key == coverImageURLs[j].key) {
              this.similarDocuments[i].coverImageURL = coverImageURLs[j].url
            }
          }
         }
       }
      }).catch(error => {
        console.error(error)
      })
    } else {
    }
  }

  generateFields(templateFields: TemplateField[]) {
    let fields: PostField[] = [];
    for (let i = 0; i < templateFields.length; i++) {
      let placeholder = ""
      try {
        const parsed = JSON.parse(templateFields[i].contentJson)
        placeholder = parsed.placeholder || "type here"
      } catch (error) {
        placeholder = "type here"
      }
      fields.push({key: templateFields[i].key, content: "", "placeholder": placeholder, type: templateFields[i].type, noteType: templateFields[i].noteType, sequence: i, "links": [], "uid": this.firestore.generateUID(), "date": "", isExpanded: false, label: templateFields[i].name}) // add actual field
    }
    return fields
  }

  getTemplateIndex(templateKey: string) {
    for (let i = 0; i < this.templates.length; i++) {
      if (this.templates[i].key == templateKey) {
        return i
      }
    }
    return -1
  }

  launchPostDialog(postKey: string, postName: string, postHTMLName: string, isNewPost: boolean) {
    this.firestore.getPost(this.organizationKey, postKey).then((result) => {
      const embedding = result.get("embedding")
      const templateKey = result.get("templateKey")
      const templateName = this.templates.find(t => t.key == templateKey)?.name || ""
      let post: Post = {"authorKey": result.get("authorKey"), "authorName": result.get("authorName"), "categoryKey": "", "color": result.get("color"), "commentCount": result.get("commentCount"), "contentRowsCount": result.get("contentRowsCount"), "contentType": result.get("contentType"), "coverImageURL": result.get("coverImageURL"), "dateOfCreation": result.get("dateOfCreation"), "dateOfUpdate": result.get("dateOfUpdate"), "fields": result.get("fields"), "formattedDate": result.get("formattedDate"), "imageURLs": result.get("imageURLs"), "isDeleted": result.get("isDeleted"), "isDownloadAvailable": result.get("isDownloadAvailable"), "isNewPost": false,  "key": postKey, "lastCommentDate": result.get("lastCommentDate"), "loggedUserDisplayName": result.get("loggedUserDisplayName"), "loggedUserKey": result.get("loggedUserKey"), "name": result.get("name"), "nameHTML": result.get("nameHTML"), "organizationKey": this.organizationKey, "projectKey": result.get("projectKey"), "projectName": result.get("projectName"), "tags": result.get("tags"), "templateKey": templateKey, "title": result.get("title"), "viewCount": result.get("viewCount"), "embedding": embedding, "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": result.get("progressPercent"), "startDate": result.get("startDate"), "endDate": result.get("endDate"), "manHours": result.get("manHours"), "isSelected": result.get("isSelected") || false, "templateName": templateName, "isCompleted": false, "parentName": "", "areKidsColored": false, "description": "", "isParent": false, "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "areKidsTagged": false, "milestoneKey": "", "isChecked": false, "fileType": result.get("type") || ""}
      this.firestore.getWorkpackageFields(this.organizationKey, post.key).then(f => {
        let fields = f
        if (fields == undefined && post.contentType != "canvas") { // in case of canvas in knowledge base do not generate template fields
          let templateIndex = this.getTemplateIndex(post.templateKey)
          fields = this.generateFields(this.templates[templateIndex].fields)
        }
        if (post.contentType != "canvas") { // for posts open popup
          const dialogRef = this.dialog.open(AddworkpackagedialogComponent, {
            disableClose: true,
            panelClass: "dialog-container",
            width: '95vw',
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: 'calc(100vh - 50px)',
            //enterAnimationDuration,
            //exitAnimationDuration,
            data: {
              post: post,
              menuItems: this.menuItems,
              key: post.key,
              name: postName,
              HTMLname: postHTMLName,
              isNewPost: isNewPost,
              organizationKey: this.organizationKey,
              projectKey: post.projectKey,
              projectName: post.projectName,
              color: post.color,
              content: post.nameHTML,
              title: post.title,
              viewCount: post.viewCount,
              userId: this.userId,
              userDisplayName: this.loggeduserDisplayname,
              loggedUserKey: this.userId,
              templateKey: post.templateKey,
              fields: fields,
              templates: this.templates,
              fieldKeyWithLinks: this.fieldKeyWithLinks,
              channelKey: post.key,
              tags: post.tags,
              coverImageURL: post.coverImageURL,
              contentType: post.contentType,
              embedding: post.embedding,
              isRead: post.isRead,
              isTop: post.isTop,
              isFavourite: post.isFavourite,
              isReadOnly: this.isReadOnly,
              type: "post",
              embeddingModel: this.embeddingModel,
              startDate: post.startDate,
              endDate: post.endDate,
              manHours: post.manHours,
              progressPercent: post.progressPercent
            },
          });
          dialogRef.afterClosed().subscribe((result: any) => { // when post or task dialog is closed, store data in the database
            post.key = ""
            if ((result != undefined)&&(result != "")) {
              if (result.isDownloadAvailable == undefined) {
                result.isDownloadAvailable = false
              }
              let color = result.color
              let areKidsColored = result.areKidsColored
              let name = result.name
              let nameHTML = result.nameHTML
              let parentName = ""//result.parentName
              let contentType = result.contentType
              if (result.isDeleted == true) {
                const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
                  data: {"content": "Are you sure to remove this task?", "onlyCloseButton": false}
                });
                dialogConfirmingRef.afterClosed().subscribe((r) => {
                  if (r == true) {
                    this.firestore.removePost(result.key, this.organizationKey, this.projectKey)
                    this.firestore.showSnackBar("The task has been deleted.");
                  }
                })
              } else {
                this.firestore.updateWorkpackageName(this.organizationKey, this.projectKey, this.projectName, postKey, this.userId, this.loggeduserDisplayname, name, parentName, contentType, nameHTML)
                this.firestore.updateWorkpackageFields(this.organizationKey, postKey, result.fields)
                this.firestore.updateWorkpackageColor(this.organizationKey, postKey, color, areKidsColored)
              }
            }
          });
        } else { // for canvases just redirect to canvas
          let canvasKey = post.key
          this.router.navigate(["canvas/"+this.organizationKey+"/"+this.projectKey+"/"+canvasKey])
        }
      })
    })
  }
}
